import { HStack } from '@cbhq/cds-web/layout/HStack';
import { Interactable } from '@cbhq/cds-web/system';

type Props = {
  children: React.ReactNode;
  handleOnClick: () => void;
  accessibilityLabel: string;
  testID?: string;
  disabled?: boolean;
  height?: string | number;
};

export function ItemContainer({
  children,
  handleOnClick,
  testID,
  accessibilityLabel,
  disabled,
  height,
}: Props) {
  return (
    <Interactable
      as="button"
      background="transparent"
      // padding={0}
      onClick={handleOnClick}
      width="100%"
      testID={testID ?? 'user-switcher-item-container'}
      accessibilityLabel={accessibilityLabel}
      disabled={disabled}
    >
      <HStack
        width="100%"
        height={height ?? '64px'}
        paddingY={1}
        paddingX={2}
        gap={2}
        alignItems="center"
      >
        {children}
      </HStack>
    </Interactable>
  );
}
